import { z } from 'zod';

export const issueInviteSchema = z.object({
  email: z.string().email(),
  role_id: z.string().uuid(),
});
export type IssueInviteInput = z.infer<typeof issueInviteSchema>;
